let printWindow = {
    init: () => {
        const printBtns = document.querySelectorAll(".js-print-window");

        const printWdw = () => {
            return () => {
                window.print();
            }
        }
        if (printBtns) {
            for (const printBtn of printBtns) {
                printBtn.addEventListener("click", printWdw());
            }
        }
    }
}

export default printWindow;